import { Flex, HStack, Stack, Text } from '@chakra-ui/react';
import { useCallback } from 'react';
import { ChevronRightIcon, Paragraph, PicturesIcon } from 'ui-components';
import { FEATURE_FLAGS } from '~/constants';
import { useFeature } from '~/hooks/useFeatureFlag/useFeature';
import customTheme from '~/styles/theme';

import { useDropActions } from './sidebar/useDropActions';

export const PlatformContent = () => {
  const isMediaKitsContentFFEnabled = useFeature(
    FEATURE_FLAGS.foamMediaKitsContent,
  ).isEnabled;

  const triggerActions = useDropActions();

  const handleOpen = useCallback(() => {
    triggerActions('TalentContent');
  }, [triggerActions]);

  if (!isMediaKitsContentFFEnabled) {
    return null;
  }

  return (
    <ContentCard
      isFFEnabled={isMediaKitsContentFFEnabled}
      onOpen={handleOpen}
    />
  );
};

export const ContentCard = ({
  isFFEnabled,
  onOpen,
}: {
  isFFEnabled: boolean;
  onOpen: () => void;
}) => {
  return (
    <HStack
      backgroundColor="neutral.100"
      justifyContent="space-between"
      border={`1px solid ${customTheme.colors.primary['100']}`}
      borderRadius={8}
      padding={4}
      opacity={!isFFEnabled ? '50%' : undefined}
      _hover={{
        cursor: isFFEnabled ? 'pointer' : 'auto',
        backgroundColor: 'neutral.200',
      }}
      track-id="add-content-to-media-kit"
      onClick={isFFEnabled ? onOpen : undefined}
      as="button"
    >
      <Stack gap={2}>
        <Flex gap={1} align="center">
          <PicturesIcon boxSize={4} />
          <Text fontSize="md" fontWeight="500" color="neutral.900">
            Platform content
          </Text>
        </Flex>
        <Flex align="center" gap={2}>
          <Paragraph size="sm" color="primary.400">
            Select content to highlight.
          </Paragraph>
        </Flex>
      </Stack>
      <ChevronRightIcon boxSize={4} color="primary.300" />
    </HStack>
  );
};
